import axios from './config';

export const getBuys = ({ queryStr, params }) => {
  return axios.get(`/buys?${queryStr}`, { params }).then(res => res.data.data);
};
